import { ProjectFragment, ProjectFragmentQuery } from '../../utils/gqlModels';
import { Project } from '../../utils/model';
import { graphqlQuery } from './_graphqlQuery';
import { mapProjectGql } from './getProjectInfoGql';

const getGroupProjectsQuery = `
${ProjectFragmentQuery}
query pg($gid: ID!) {
  group(fullPath: $gid) {
    descendantGroups {
      nodes {
        fullPath
      }
    }
    projects {
      nodes {
        ...ProjectFragment
      }
    }
  }
}
`;

interface GroupProjectsGql {
  group: {
    descendantGroups: {
      nodes: {
        fullPath: string;
      }[];
    };
    projects: {
      nodes: ProjectFragment[];
    };
  };
}

const getGroupSubGroups = async (groupPath: string): Promise<string[]> => {
  const data = await graphqlQuery<GroupProjectsGql>(getGroupProjectsQuery, {
    gid: groupPath,
  });
  if (!data.group) {
    return [];
  }
  const innerGroups = data.group.descendantGroups.nodes;
  return innerGroups.map((g) => g.fullPath);
};

const getGroupProjectsGql = async (groupPath: string): Promise<Project[]> => {
  const data = await graphqlQuery<GroupProjectsGql>(getGroupProjectsQuery, {
    gid: groupPath,
  });
  if (!data.group) {
    return [];
  }
  const currentProjects = data.group.projects.nodes.map(mapProjectGql);
  return currentProjects;
};

export const getGroupProjects = async (groupPath: string): Promise<Project[]> => {
  const innerGroups = await getGroupSubGroups(groupPath);
  const innerProjects = await Promise.all(innerGroups.map(getGroupProjectsGql));
  const currentProjects = await getGroupProjectsGql(groupPath);
  return [...currentProjects, ...innerProjects.flat()];
};
